<template>
  <normal-excel-upload
    :board="board"
    title="환경에너지예산 엑셀 업로드"
    :downloadLink="downloadLink"
    tableTitle="환경에너지예산 정보"
    :useFieldCell="true"
    :readExcelData="readExcelData"
    :setSaveFormData="setSaveFormData"
    tableType="detailOnOff"

    :tableHeader="tableHeader"
    :startReadSheet="startReadSheet"
    :finishReadSheet="finishReadSheet"
  >
    <template v-slot:colgroup>
      <col width="" v-for="head in tableHeader">
    </template>
    <template v-slot:edit="{ index, data, raw, funcSave }">
      <span v-if="index === 0">{{ data }}</span>
      <span v-if="index === 1"><field-selector class="mx-1" v-model="data.id" @select="(field) => {onSelectField(field, funcSave)}"/></span>
      <span v-if="index === 2"><ml-input class="mx-1" :value="data" type="number" :min-value="2000" :max-value="9999" @input="(year) => { onInputNumber(year, funcSave) }"/></span>
      <span v-if="index === 3"><ml-input class="mx-1" :value="data" type="number" :min-value="1" :max-value="12" @input="(month) => { onInputNumber(month, funcSave) }"/></span>
      <span v-if="index === 4">{{ getTotalData('편성액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 5">{{ getTotalData('본예산', '', raw.detailData) | comma}}</span>
      <span v-if="index === 6">{{ getTotalData('추경예산', '', raw.detailData) | comma}}</span>
      <span v-if="index === 7">{{ getTotalData('결산추경', '', raw.detailData) | comma}}</span>
      <span v-if="index === 8">{{ getTotalData('지출액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 9">{{ getTotalData('지출잔액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 10">{{ getTotalData('집행률', '', raw.detailData) | percent}}</span>
    </template>
    <template v-slot:column="{ index, data, raw }">
      <span v-if="index === 0">{{ data }}</span>
      <span v-if="index === 1">{{ data.field_name }}</span>
      <span v-if="index === 2">{{ data }}</span>
      <span v-if="index === 3">{{ data }}</span>
      <span v-if="index === 4">{{ getTotalData('편성액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 5">{{ getTotalData('본예산', '', raw.detailData) | comma}}</span>
      <span v-if="index === 6">{{ getTotalData('추경예산', '', raw.detailData) | comma}}</span>
      <span v-if="index === 7">{{ getTotalData('결산추경', '', raw.detailData) | comma}}</span>
      <span v-if="index === 8">{{ getTotalData('지출액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 9">{{ getTotalData('지출잔액', '', raw.detailData) | comma}}</span>
      <span v-if="index === 10">{{ getTotalData('집행률', '', raw.detailData) | percent}}</span>
    </template>
    <template v-slot:columnDetail="{ detailData, funcSave }">
      <table class="w-full" style="border: none;">
        <colgroup>
          <col width="40px"/>
          <col width="53px"/>
          <col width="" v-for="head in tableHeader">
          <col width="94px"/>
        </colgroup>
        <thead>
          <tr style="position: sticky; top:0px; z-index: 1">
            <th colspan="6">항목</th>
            <th class="text-right">편성액</th>
            <th class="text-right">본예산</th>
            <th class="text-right">추경예산</th>
            <th class="text-right">결산추경</th>
            <th class="text-right">지출액</th>
            <th class="text-right">지출잔액</th>
            <th class="text-right">집행률</th>
            <th>수정/삭제</th>
          </tr>
        </thead>
        <tbody v-for="group in groups">
          <tr style="position: sticky; top:50px; z-index: 1">
            <th colspan="6">{{ group }}</th>
            <th class="text-right">{{ getTotalData('편성액', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('본예산', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('추경예산', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('결산추경', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('지출액', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('지출잔액', group, detailData[group].data) | comma }}</th>
            <th class="text-right">{{ getTotalData('집행률', group, detailData[group].data) | percent }}</th>
            <th></th>
          </tr>
          <fragment v-for="(row, rowIndex) in detailData[group].data">
            <tr v-if="row.edit">
              <td colspan="6"><ml-input v-model="row.group"/></td>
              <td class="text-right">{{ getData('편성액', row.data) | comma }}</td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.본예산" @input="funcSave(detailData)"/></td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.추경예산" @input="funcSave(detailData)"/></td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.결산추경" @input="funcSave(detailData)"/></td>
              <td class="p-1 text-right"><NumberInput v-model="row.data.지출액" @input="funcSave(detailData)"/></td>
              <td class="text-right">{{ getData('지출잔액', row.data) | comma }}</td>
              <td class="text-right">{{ getData('집행률', row.data) | percent }}</td>
              <td>
                <row-edit-tool
                  :data="rowIndex"
                  v-model = "row.edit"
                  :use-delete="!row.fixed"
                  @open-edit-mode="detailOpenEditMode(detailData, row, funcSave)"
                  @close-edit-mode="detailCloseEditMode(detailData, row, funcSave)"
                  @cancel="detailEditCancel(detailData, row, funcSave)"
                  @delete="detailDelete(detailData, group, rowIndex, funcSave)"
                />
              </td>
            </tr>
            <tr v-else>
              <td colspan="6">{{ row.group }}</td>
              <td class="text-right">{{ getData('편성액', row.data) | comma }}</td>
              <td class="text-right">{{ row.data.본예산 | comma }}</td>
              <td class="text-right">{{ row.data.추경예산 | comma }}</td>
              <td class="text-right">{{ row.data.결산추경 | comma }}</td>
              <td class="text-right">{{ row.data.지출액 | comma }}</td>
              <td class="text-right">{{ getData('지출잔액', row.data) | comma }}</td>
              <td class="text-right">{{ getData('집행률', row.data) | percent }}</td>
              <td class="p-2">
                <row-edit-tool
                  :data="rowIndex"
                  v-model = "row.edit"
                  :use-delete="!row.fixed"
                  @open-edit-mode="detailOpenEditMode(detailData, row, funcSave)"
                  @close-edit-mode="detailCloseEditMode(detailData, row, funcSave)"
                  @cancel="detailEditCancel(detailData, row, funcSave)"
                  @delete="detailDelete(detailData, group, rowIndex, funcSave)"
                />
              </td>
            </tr>
          </fragment>

        </tbody>
      </table>
    </template>
  </normal-excel-upload>
</template>

<script>
import NormalExcelUpload from "@/views/excel-upload/NormalExcelUpload.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import config from "/public/config";
import RowEditTool from "@/views/excel-upload/RowEditTool.vue";

export default {
  components: {
    RowEditTool,
    NumberInput,
    DateSelector,
    FieldSelector,
    NormalExcelUpload,
  },
  props: {
    board: Object,
  },
  data() {
    return {
      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%ED%99%98%EA%B2%BD%EC%97%90%EB%84%88%EC%A7%80%EC%98%88%EC%82%B0_%EC%97%91%EC%85%80%EB%93%B1%EB%A1%9D.xlsx`,
      tableHeader: ['No.', '사업장명',	'대상년도', '월', '편성액', '본예산', '추경예산', '결산추경', '지출액', '지출잔액', '집행률'],
      groups: [
        "환경 시설투자", "환경 관리 인건비", "환경 시설 운영비", "폐기물 처리비", "환경 컨설팅", "환경 측정비", "교육훈련비"
      ],
      fixedItems: {},

      form: {
        stdInfo: {
          field_id: 0,
          field_name: "",
        },
        환경에너지예산: {},
        total: {},
      },
      header: {
        year: 0,
        month: 0,
        date: "",
        full: "",
      },

      nextGroupName: ""
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  methods: {
    onSelectField(field, funcSave) {
      const data = {
        id: field.id,
        field_name: field.field_name,
      }
      const errorMSG = field.id ? "" : "입력된 데이터가 검색되지 않습니다.";
      funcSave(data, errorMSG)
    },
    onInputNumber(number, funcSave) {
      if (number) {
        const errorMSG = !isNaN(Number(`${number}`)) ? "" : "숫자만 입력 가능합니다.";
        funcSave(number, errorMSG)
      } else {
        funcSave("", "");
      }
    },
    readExcelData (rowNumber, cells, dataTypes, func) {
      if (rowNumber === 1) {
        // 사업장명
        const field = func.findFieldByFieldName(cells[8]);
        if (field) {
          this.form.stdInfo.field_id = field.id
          this.form.stdInfo.field_name = field.field_name
        } else {
          this.form.stdInfo.field_id = 0
          this.form.stdInfo.field_name = cells[8]
        }
      }
      else if (rowNumber === 2) {
        // 대상년도
        this.header.year = cells[8];
      }
      else if (rowNumber === 3) {
        // 월
        this.header.month = cells[8];
      }
      else if (rowNumber >= 8) {
        const error = [];
        const 항목 = cells[1];
        if (항목 === '계') return
        if ([...this.groups].indexOf(항목) >=0) this.nextGroupName = 항목
        else {
          if (this.nextGroupName) {
            const key = this.nextGroupName;
            if (!this.form.환경에너지예산[key]) this.form.환경에너지예산[key] = {
              data: [],
              fixed: false,
              open: false,
            };

            const 본예산 = !isNaN(Number(cells[3])) ? Number(cells[3]) : 0
            const 추경예산 = !isNaN(Number(cells[4])) ? Number(cells[4]) : 0
            const 결산추경 = !isNaN(Number(cells[5])) ? Number(cells[5]) : 0
            const 지출액 = !isNaN(Number(cells[6])) ? Number(cells[6]) : 0

            const 편성액 = 본예산 + 추경예산 + 결산추경;
            const 지출잔액 = 편성액 - 지출액;
            const 집행률 = 지출액 / 편성액;
            this.form.환경에너지예산[key].data.push({
              data: {
                편성액,
                본예산: cells[3],
                추경예산: cells[4],
                결산추경: cells[5],
                지출액: cells[6],
                지출잔액,
                집행률,
              },
              group: 항목,
              fixed: this.fixedItems[key] ? this.fixedItems[key].indexOf(항목) >= 0 : false,
            })
          }
        }
      }
    },
    startReadSheet (sheet, func) {
      this.form.환경에너지예산 = {}
    },
    finishReadSheet (sheet, func) {
      const error = [];
      const mainData = []; // No. 사업장명 대상년도 월 편성액 본예산 추경예산 결산추경 지출액 지출잔액 집행률
      const detailData = this.form.환경에너지예산

      mainData.push(func.rowIndex)
      mainData.push({
        id: this.form.stdInfo.field_id,
        field_name: this.form.stdInfo.field_name,
      })
      mainData.push(this.header.year)
      mainData.push(this.header.month)
      mainData.push(this.getTotalData('편성액', "", detailData))
      mainData.push(this.getTotalData('본예산', "", detailData))
      mainData.push(this.getTotalData('추경예산', "", detailData))
      mainData.push(this.getTotalData('결산추경', "", detailData))
      mainData.push(this.getTotalData('지출액', "", detailData))
      mainData.push(this.getTotalData('지출잔액', "", detailData))
      mainData.push(this.getTotalData('집행률', "", detailData))

      console.log("mainData[0].id", mainData[1])
      if (mainData[1].id === 0) {
        error[1] = "입력된 데이터가 검색되지 않습니다."
      }
      if (isNaN(Number(mainData[2])) || mainData[2] === 0) {
        error[2] = "대상년도를 입력해주세요."
      }
      if (isNaN(Number(mainData[3])) || mainData[3] === 0) {
        error[3] = "월을 입력해주세요."
      }
      func.save(mainData, detailData, error)
    },

    setSaveFormData(datas, stdInfo) {
      const mainData = datas.mainData;
      const form = {
        stdInfo: {
          ...stdInfo,
          field_id: mainData[1].id,
          field_name: mainData[1].field_name,
        },
        환경에너지예산: datas.detailData,
        total: {
          "편성액": mainData[4],
          "본예산": mainData[5],
          "추경예산": mainData[6],
          "결산추경": mainData[7],
          "지출액": mainData[8],
          "지출잔액": mainData[9],
          "집행률": mainData[10],
        },
        fileList: [],
      }

      const header = {
        year: mainData[2],
        month: mainData[3],
        date: '',
        full: `${mainData[2]}-${mainData[3]}-01`
      };

      return {
        header,
        body: form
      }
    },

    getData(key, data) {
      const 본예산 = !isNaN(Number(data['본예산'])) ? Number(data['본예산']) : 0;
      const 추경예산 = !isNaN(Number(data['추경예산'])) ? Number(data['추경예산']) : 0;
      const 결산추경 = !isNaN(Number(data['결산추경'])) ? Number(data['결산추경']) : 0;
      const 지출액 = !isNaN(Number(data['지출액'])) ? Number(data['지출액']) : 0;

      if (key === '편성액') {
        return 본예산 + 추경예산 + 결산추경;
      } else if (key === '지출잔액') {
        return (본예산 + 추경예산 + 결산추경) - 지출액;
      } else if (key === '집행률') {
        return 지출액 / (본예산 + 추경예산 + 결산추경);
      } else {
        return data[key];
      }
    },

    getTotalData(key, group, data) {
      const _totalData = (key, group, _data) => {
        if (_data && _data.length > 0) {
          if (key === '집행률') {
            const 지출액 = _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['지출액'] || 0);
            }, 0);
            const 편성액 = data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['편성액'] || 0);
            }, 0);
            return 지출액 / 편성액;
          } else {
            return _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data[key] || 0);
            }, 0);
          }
        }
        return 0;
      }
      if (group) {
        return _totalData(key, group, data);
      } else {

        if (key === '집행률') {
          let 편성액 = 0;
          let 지출액 = 0;
          for (const group of this.groups) {
            편성액 += _totalData('편성액', group, data[group].data);
            지출액 += _totalData('지출액', group, data[group].data);
          }
          return 지출액 / 편성액;
        } else {
          return this.groups.reduce((acc, cur) => {
            return Number(acc || 0) + Number(_totalData(key, cur, data[cur].data) || 0);
          }, 0);
        }
      }
      return "0";
    },

    detailOpenEditMode (detailData, row, funcSave) {
      row.edit = true;
      row.oldData = JSON.parse(JSON.stringify(row.data));
      funcSave(detailData);
    },

    detailCloseEditMode (detailData, row, funcSave) {
      delete row.edit;
      delete row.oldData;
      funcSave(detailData);
    },

    detailEditCancel (detailData, row, funcSave) {
      row.data = JSON.parse(JSON.stringify(row.oldData));
      delete row.edit;
      delete row.oldData;
      funcSave(detailData);
    },

    detailDelete (detailData, group, rowIndex, funcSave) {
      if (this.useDelete) {
        detailData[group].data.splice(rowIndex, 1);
        funcSave(detailData);
      }
    }
  },
};
</script>

<style scoped lang="scss">
table {
  border-collapse: separate;
  border-spacing: 0;
  border-size: 0;
  width: 100%;

  th, td {
    border: none;
    border-bottom: 1px solid #cdcdcd;

    &.text-right {
      padding-right: 0.5rem;
    }
  }
}
</style>
